
const myFilter = {
    /**
     * [timeAgo 多长时间以前]
     * @param  {[type]} dateString [时间字符串]
     * @return {[type]}            [7天前]
     */
    timeAgo (dateString) {
        if (!dateString) return
        const pStamp = +new Date(dateString.replace(/-/g, '/')) / 1000
        const cStamp = +new Date() / 1000
        const dStamp = cStamp - pStamp

        if (dStamp > 24 * 60 * 60) {
            return Math.floor(dStamp / 24 / 60 / 60) + '天前'
        }
        if (dStamp > 60 * 60 && dStamp <= 24 * 60 * 60) {
            return Math.floor(dStamp / 60 / 60) + '小时前'
        }
        if (dStamp > 60 && dStamp <= 60 * 60) {
            return Math.floor(dStamp / 60) + '分钟前'
        }
        if (dStamp <= 60) {
            return '刚刚'
        }
    },
    /**
     * [highlight description]
     * @param  {[type]} keywords [description]
     * @param  {[type]} value    [description]
     * @return {[type]}          [description]
     */
    highlight (keywords, value) {
        
        let findText = value.split(keywords)
        return findText.join('<span class="highlight">' + keywords + '</span>')

        // let keywordsArr = keywords.replace(/[\s]+/g, ' ').split(' ')
        // keywordsArr.forEach( (key, index) => {
        //     value = value.replace(new RegExp('' + key, 'gi'), '<span style="color: red">' + key + '</span>')
        // })
        // return value
    },
    /**
     * [数量 校正]
     * @param  {[type]} number    [description]
     * @return {[type]}          [description]
     */
    validCount(number) {
        return number === null ? 0 : number
    }
}

export default myFilter


// WEBPACK FOOTER //
// ./src/utils/filters.js